// Module
var code = "<variant-overview\n  article-node-group=\"vm.nodeGroup\"\n  is-product-development=\"vm.variant.isProductDevelopment\"\n  variant-id=\"vm.variant.id\"\n></variant-overview>\n";
// Exports
module.exports = code;